import {
  SlButton
} from "./chunk.5SUGJ4EB.js";

// src/components/button/button.ts
var button_default = SlButton;
SlButton.define("sl-button");

export {
  button_default
};
